import Alert from '@mui/material/Alert'
import i18n from 'i18n-js'
import moment from 'moment'
import { memo } from 'react'
import { useSelector } from 'react-redux'

import useCombinedPremiumAdData from '../../lib/useCombinedPremiumAdData'
import { brandNameLogoByIdSelector } from '../../stores/app/selectors'
import { getAll } from '../../stores/automations/selectors'
import { facebookPagesById } from '../../stores/facebookPages/selectors'

import AutomationIcon from './AutomationIcon'

/**
 * @typedef {{
 *  id: number | string
 * }} PremiumAdAutomationBannerProps
 */

/** @type {React.FC<PremiumAdAutomationBannerProps>} */
const PremiumAdAutomationBanner = (props) => {
  // TODO It's a million times easier to stumble around with console.log / redux
  // devtools than it is to look into selectors in this repo.
  const { campaign, adCreativeTemplate } = useCombinedPremiumAdData(props.id)
  // TODO This selector combines like 8 million things, to get the list of
  // brands from retailer accounts.
  // Them "complication" comes from the fact that retailer accounts come from
  // the current user, or somewhere else in redux when logging in as an internal
  // user.
  // Why not ... just store all the retailer accounts in the one place.
  // Or, store all the brands in the one place and update them when the user
  // logs in / retailer accounts are fetched.
  // This can be done without any epics, just pure redux.
  // It also needlessly throws away potentially useful info on brands, and
  // renames things like `brand.name` to `brand.brandName`.
  // o_O
  const brands = useSelector(brandNameLogoByIdSelector)
  const automations = useSelector(getAll)
  const facebookPages = useSelector(facebookPagesById)

  // No campaign or automations means there's no reason to render.
  if (
    !campaign ||
    automations.length === 0 ||
    !adCreativeTemplate ||
    !campaign.automated
  ) {
    return null
  }

  const automation = automations.find(
    (x) =>
      x.brand_id === campaign.brand_id &&
      x.state === 'enabled' &&
      !!facebookPages[x.customization.facebook_page_id],
  )

  // If there's no automation or the automation is not enabled there's no reason
  // to render.
  if (!automation) {
    return null
  }

  const brand = brands[campaign.brand_id]
  const canCustomize =
    adCreativeTemplate.allow_url_override ||
    adCreativeTemplate.allow_call_to_action_override
  const startsAt = moment(campaign.starts_at)
  let message = i18n.t('automations.campaignIsAutomated', {
    brandName: brand.brandName,
    startsAt: startsAt.format('M/D'),
  })

  if (canCustomize) {
    message = `${message} ${i18n.t(
      'automations.campaignIsAutomatedCustomization',
    )}`
  }

  return (
    <Alert icon={<AutomationIcon />} severity="info" style={{ margin: '1em' }}>
      {message}
    </Alert>
  )
}

export default memo(PremiumAdAutomationBanner)
